var DB_ProductMenu = {
    prevScroll:0,
    init:function(){
        document.addEventListener("scroll", function(){
            DB_ProductMenu.scroll();
        });
        DB_ProductMenu.scroll();

         document.querySelectorAll(".DB-product-menu__container .menu").forEach(function(menu){
             menu.addEventListener("click", function(){
                 DB_ProductMenu.scroll_to_section(menu.getAttribute("data-target"));
             })
        });

        if(document.querySelectorAll(".DB-product-menu__container .btn-with-variants").length > 0){
            document.querySelector(".DB-product-menu__container .btn-with-variants").addEventListener("click", function(e){
                console.log("CLICK BTN-WITH-VARIANTS")
                e.stopPropagation();
                e.preventDefault();

                DB_ProductMenu.scroll_to_section( document.querySelector(".DB-product-menu__container .btn-with-variants").getAttribute("data-target"));
            })
        }

        // Handle anchor button clicks for smooth scrolling
        document.querySelectorAll(".DB-product-menu__container a[href]").forEach(function(anchorBtn){
            anchorBtn.addEventListener("click", function(e){
                const href = anchorBtn.getAttribute("href");
                
                // Check if it's an internal anchor link (starts with # or contains #)
                if(href && href.includes("#")){
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Extract the target ID from the href
                    const targetId = href.includes("#") ? href.split("#")[1] : null;
                    
                    if(targetId){
                        // Try to find the target element by ID first
                        const targetElement = document.getElementById(targetId);
                        
                        if(targetElement){
                            console.log("SMOOTH SCROLL TO:", targetId);
                            window.scrollTo({
                                top: targetElement.offsetTop - 75,
                                left: 0,
                                behavior: "smooth",
                            });
                        } else {
                            // Fallback: try to use the data-target attribute if available
                            const dataTarget = anchorBtn.getAttribute("data-target");
                            if(dataTarget){
                                DB_ProductMenu.scroll_to_section(dataTarget);
                            }
                        }
                    }
                }
                // If it's an external link, let it behave normally (don't prevent default)
            });
        });
    },
    scroll_to_section:function(section_name){
        console.log("SCROLL TO SECTION : " + section_name);
        document.querySelectorAll(".target-navigation").forEach(function(target){
            if(target.getAttribute("data-navigation") == section_name){
				console.log('ancre ok')
                window.scrollTo({
                    top: target.offsetTop - 75,
                    left: 0,
                    behavior: "smooth",
                });
            }
        });
    },
    scroll:function(){


        var _current_target = "";
        document.querySelectorAll(".target-navigation").forEach(function(target){
            if(window.scrollY > target.offsetTop - 150){
                _current_target = target.getAttribute("data-navigation");
            }
        });
        // document.querySelectorAll(".DB-product-menu__container .menu").forEach(function(menu){
        //     if(menu.getAttribute("data-target") == _current_target){
        //         menu.classList.add("current");
        //     }else{
        //         menu.classList.remove("current");
        //     }
        // });


        var _offset_top = document.querySelector(".DB-product-menu").getBoundingClientRect().top;
        /*if(window.scrollY > document.querySelector(".DB-product-menu").offsetTop){*/
        if(_offset_top < 0){
            document.querySelector(".DB-product-menu").classList.add("fixed");
        }else{
            document.querySelector(".DB-product-menu").classList.remove("fixed");
        }

        // if(window.scrollY < DB_ProductMenu.prevScroll){
        //     document.querySelector(".DB-product-menu").classList.add("scroll-up");
        //     document.querySelector(".DB-product-menu").classList.remove("scroll-down");
        // }else{
        //     document.querySelector(".DB-product-menu").classList.remove("scroll-up");
        //     document.querySelector(".DB-product-menu").classList.add("scroll-down");
        // }

        DB_ProductMenu.prevScroll = window.scrollY;
    }
}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".DB-product-menu").length > 0){
        DB_ProductMenu.init();
    }
})